import { Component } from 'react';
import { RingLoader } from 'react-spinners';

export default class LoadingSpinner extends Component {
    render() {
        return(
            <div hidden={!this.props.loading} className='loading-box'>
                <div className='loading'>
                    <RingLoader
                        color={'#1220bc'}
                        loading={this.props.loading}
                    />
                </div>
            </div>
        )
    }
}